/*eslint-disable */
import request from '../../Utils/curl'

let inviteUser = {
  /**
   * inviteUser
   * Centralized method pointing to the single endpoint: unified_user_invite
   * Handles user invitations for SPCM, GPaths, TestSeries, GidePlus, and IEC.
   */
  async inviteUser (context, inviteObj) {
    try {
      let post_data = new FormData();
    
      for (let key in inviteObj) {
        if (typeof inviteObj[key] == 'object') {
          post_data.append(key, JSON.stringify(inviteObj[key]));
        }
        else if (inviteObj[key] !== undefined && inviteObj[key] !== null && inviteObj[key] !== "") {
          post_data.append(key, inviteObj[key]);
        }
      }

      return await request.curl(context, "invite_user", post_data)
        .then(async response => {
          return response;
        });
    }
    catch (err) {
      console.error('Exception occurred at inviteUser() and Exception:', err.message);
      return { resp_status: false, resp_msg: err.message };
    }
  }
}

export {
  inviteUser
}
